import { Component } from "@angular/core";
import { AppSettings } from "../../app.settings";

@Component({
  selector: "forbidden",
  template: `
  <br />
  <div>
      <h1 i18n>Forbidden</h1>
      <div i18n>
          We are sorry, but you do not have access to this page or resource for some reason.
      </div>
      <br />
      <div>
          <button 
              mat-raised-button 
              color="primary" 
              (click)="goBack();" i18n>Go Back</button>
      </div>
  </div>`
})
export class ForbiddenComponent {
  constructor(
    public appSettings: AppSettings
  ) { }

  ngOnInit() { }

  public goBack() { }
}
